import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";

export class ComparisonSymbolsLastPriceComponent implements IComponent {
    public id = StringHelpers.newGuid();
    public isShow = false;
    
    private element: HTMLElement;
    private base: IChartContainer;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.onResize();
    }

    public show(html: string) {
        this.element.setInnerHtml(html);
        this.isShow = true;
        setTimeout(() => {
            this.setLastPriceLabelPosition();
        }, 200);
    }

    public hide() {
        this.element.setInnerHtml('');
        this.isShow = false;
    }

    public setLastPriceLabelPosition() {
        if (!this.isShow || !this.base.tiChartSeries || !this.base.tiChartSeries.tiComparisionsData.length) {
            return;
        }

        const yAxis: any = this.base.tiChartSeries.highStockChart?.yAxis[0];
        if (!yAxis) {
            return;
        }

        for (const comparisonData of this.base.tiChartSeries.tiComparisionsData) {
            const lastPriceWrapper = this.element.findFirst('.last-price-wrapper.comparison-last-price-' + comparisonData.symbol);
            const pElement = lastPriceWrapper?.findFirst('p');
            if (!lastPriceWrapper || !pElement || !comparisonData.points?.length) {
                continue;
            }

            const lastDataPoint = comparisonData.points[comparisonData.points.length - 1];
            let close = 0;

            if (this.base.tiChartSeries.chartStyleSettings?.isComparisonSymbolPercentageMode) {
                close = this.base.tiChartSeries.highChartComparisonBuilder.getPercentage(lastDataPoint, comparisonData.ratio);
            } else {
                close = lastDataPoint.close * comparisonData.ratio
            }

            const currentValue =  yAxis.toPixels(close) ?? 0;
            const myHeight = lastPriceWrapper.clientHeight / 2;
            const valueTop =  (yAxis.toPixels(yAxis.max) ?? 0) - 16;
            const valueBottom =  (yAxis.toPixels(yAxis.min) ?? 0) - 16;
            let top = currentValue - myHeight;
            if (close > yAxis.max || valueTop > top) {
                top = valueTop;
            } else if (close < yAxis.min || top > valueBottom) {
                top = valueBottom;
            }

            const displayResult = this.base.tiChartSeries.highChartComparisonBuilder.getCurrentDisplayValue(comparisonData, lastDataPoint.xValue);
            pElement.innerHTML = `${comparisonData.symbol} ${displayResult.percentageChange}`;
            lastPriceWrapper.style.top = top + 'px';
        }
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setLastPriceLabelPosition();
            }, 250);
        });
    }
}